<section class="roadmap pageHeight" id="roadmap">
  <h2 class="section-title">{{"roadmap.title" | translate}}</h2>
  <!-- <p class="section-desc fw-semibold">{{"roadmap.para" | translate}}</p> -->

  <div class="roadmap-wrapper pt-0">
    <accordion [closeOthers]="true" [isAnimated]="true">
      <accordion-group *ngFor="let item of items; let i = index" [(isOpen)]="item.isOpen">
        <div class="roadmap-header position-relative w-100 d-flex justify-content-between"
          [ngClass]="{ 'open': item.isOpen }" accordion-heading>
          <span>{{ i + 1 }}. {{ item.heading | translate }}</span>
        </div>
        <div accordion-panel class="roadmap-panel mt-0">
          <span class="para fw-regular" [innerHTML]="item.content | translate"></span>
        </div>
      </accordion-group>
    </accordion>
  </div>

  <img src="/assets/images/gif/roadmap_gif.gif" alt="roadmap man" class="img-fluid roadmap-man">
  <div class="drop-shadow d-lg-inline-block d-none" >
    <a routerLink="/{{currentLanguage}}"  fragment="tokenomics" (click)="navigateToPage('tokenomics')" class="btn btn-primary animation py-3 font-20 fw-semibold"> {{"roadmap.tokenomics_btn" | translate}}</a>
  </div>
    <img src="/assets/images/png/mob-line-2.png" class="img-fluid d-block d-lg-none mb-5 mob-line-bottom" alt="line" >

</section>